<template>
  <div class="loanUser">
    <div class="nav">
      <div class="nav_item">
        手机号：
        <a-input
          placeholder="请输入手机号"
          v-model.trim="phone"
          @keyup.enter="query(1)"
          allow-clear
        ></a-input>
      </div>
      <div class="nav_item">
        来源：
        <a-input
          placeholder="请输入来源"
          v-model.trim="channel"
          @keyup.enter="query(1)"
          allow-clear
        ></a-input>
      </div>
      <div class="nav_item">
        是否允许加微：
        <a-select
          v-model="allowAddWechat"
          placeholder="请选择是否允许加微"
          class="select-tag"
          @change="query(1)"
        >
          <a-select-option
            v-for="i in allowAddWechatList"
            :key="i.id"
            :value="i.id"
            >{{ i.name }}</a-select-option
          >
        </a-select>
      </div>
    </div>
    <div class="nav">
      <div style="width: 510px">
        创建时间：
        <a-date-picker
          showTime
          :disabledDate="disabledLastLoginStartDate"
          format="YYYY-MM-DD HH:mm:ss"
          v-model="lastLoginDateStart"
          placeholder="开始时间"
        />
        <i style="display: inline-block; margin-left: 20px"></i>
        <a-date-picker
          showTime
          :disabledDate="disabledLastLoginEndDate"
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="结束时间"
          v-model="lastLoginDateEnd"
        />
      </div>
    </div>
    <div class="userList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="display: inline-block; margin-right: 20px"></i>
      <a-button type="primary" @click="Export">导出</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="tablePagination"
      :loading="loadingTable"
      :rowKey="(record) => record.id"
      size="middle"
    >
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="getLogList(record)">撞库记录</a>
      </span>
    </a-table>
    <a-modal
      title="导出平台数据"
      v-model="addKeyVisible"
      :maskClosable="false"
      :after-close="addKeyClose"
      class="action-class"
      width="670px"
    >
      <a-form>
        <a-form-item
          label="创建时间:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-date-picker
            showTime
            :disabledDate="disabledLastLoginStartDate"
            format="YYYY-MM-DD HH:mm:ss"
            v-model="lastLoginDateStart"
            placeholder="开始时间"
          />
          <i style="display: inline-block; margin-left: 20px"></i>
          <a-date-picker
            showTime
            :disabledDate="disabledLastLoginEndDate"
            format="YYYY-MM-DD HH:mm:ss"
            placeholder="结束时间"
            v-model="lastLoginDateEnd"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addKeyVisible = false">取消</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="addTask_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>
    <a-modal
      title="撞库记录"
      v-model="logVisible"
      :maskClosable="false"
      class="action-class"
      width="1200px"
    >
      <a-table
        :columns="logTableColumns"
        :dataSource="logTableDataSource"
        :pagination="false"
        :rowKey="(record) => record.id"
        size="middle"
      >
        <span slot="action" slot-scope="text, record">
          <a-button type="link" :disabled="!record.json" @click="detail(record)"
            >详情</a-button
          >
        </span>
      </a-table>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="logVisible = false">关闭</a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="详情"
      v-model="detailVisible"
      :maskClosable="false"
      class="action-class"
      width="1200px"
    >
      <a-table
        :columns="detailTableColumns"
        :dataSource="detailTableDataSource"
        :pagination="false"
        :rowKey="(record) => record.question"
        size="middle"
      >
      </a-table>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="detailVisible = false">关闭</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import api from "../lib/userList.js";
import moment from "moment";

export default {
  name: "userList",
  data() {
    return {
      title: "",
      phone: "",
      phoneAdd: "",
      lastLoginDateStart: null,
      lastLoginDateEnd: null,
      channel: "",
      channelAdd: "",
      allowAddWechat: undefined,
      allowAddWechatAdd: undefined,
      allowAddWechatList: [
        {
          id: 0,
          name: "否",
        },
        {
          id: 1,
          name: "是",
        },
      ],
      groupId: "",
      addKeyVisible: false,
      loading: false,
      pageNo: 1,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "用户姓名",
          dataIndex: "name",
        },
        {
          title: "手机号",
          dataIndex: "phone",
        },
        {
          title: "来源",
          dataIndex: "channel",
        },
        {
          title: "是否允许加微",
          dataIndex: "allowAddWechat",
        },
        {
          title: "年龄",
          dataIndex: "age",
        },
        {
          title: "城市",
          dataIndex: "city",
        },
        {
          title: "上次登录时间",
          dataIndex: "lastLoginTime",
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      tableDataSource: [],
      tablePagination: {},
      loadingTable: false,
      logTableColumns: [
        {
          title: "编号",
          dataIndex: "id",
          width: 100,
        },
        {
          title: "平台",
          dataIndex: "platformName",
          width: 100,
        },
        {
          title: "状态",
          dataIndex: "qualificationStatusCn",
          width: 200,
          ellipsis: true,
        },
        {
          title: "子状态",
          dataIndex: "subStatusCh",
        },
        {
          title: "失败原因",
          dataIndex: "failReason",
          width: 400,
          ellipsis: true,
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      logTableDataSource: [],
      logVisible: false,
      detailTableColumns: [
        {
          title: "问题",
          dataIndex: "question",
        },
        {
          title: "答案",
          dataIndex: "answer",
        },
      ],
      detailTableDataSource: [],
      detailVisible: false,
    };
  },
  computed: {
    lastLoginDateEndTime() {
      // 开始时间
      if (this.lastLoginDateEnd) {
        return this.$common.transformTime(this.lastLoginDateEnd);
      }
      return "";
    },
    lastLoginDateStartTime() {
      // 结束时间
      if (this.lastLoginDateStart) {
        return this.$common.transformTime(this.lastLoginDateStart);
      }
      return "";
    },
  },
  created() {
    this.today();
    this.query(1);
  },
  methods: {
    detail(val) {
      let obj = JSON.parse(val.json);
      this.detailTableDataSource.splice(0);
      for (const key in obj) {
        this.detailTableDataSource.push({ question: key, answer: obj[key] });
      }
      this.detailVisible = true;
    },
    getLogList(val) {
      api.logList({ userId: val.id }).then((res) => {
        if (res.result == 200) {
          this.logTableDataSource.splice(0);
          this.logTableDataSource.push(...res.data);
          this.logVisible = true;
        }
      });
    },
    moment,
    today() {
      let startTime = new Date();
      startTime.setHours(0);
      startTime.setMinutes(0);
      startTime.setSeconds(0);
      startTime.setMilliseconds(0);
      let endTime = new Date();
      endTime.setHours(23);
      endTime.setMinutes(59);
      endTime.setSeconds(59);
      endTime.setMilliseconds(59);
      this.lastLoginDateStart = moment(startTime, "YYYY-MM-DD HH:mm:ss");
      this.lastLoginDateEnd = moment(endTime, "YYYY-MM-DD HH:mm:ss");
    },
    addTask_submit() {
      location.href =
        process.env.VUE_APP_CURRENTMODE == "dev"
          ? process.env.VUE_APP_BASE_API
          : location.origin +
            `/api/manager/loanUser/scopeLog?startTime=${this.lastLoginDateStartTime}&endTime=${this.lastLoginDateEndTime}`;
      this.addKeyVisible = false;
    },
    addKeyClose() {
      this.today();
    },
    ExportData() {
      this.today();
      this.addKeyVisible = true;
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        pageNo: this.pageNo,
        pageSize: 10,
        phone: this.phone,
        channel: this.channel,
        allowAddWechat: this.allowAddWechat,
        startTime: this.lastLoginDateStartTime,
        endTime: this.lastLoginDateEndTime,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            let list = res.data.records;
            this.tableDataSource = list;
            this.tableDataSource.map((item) => {
              this.$set(
                item,
                "allowAddWechat",
                item.allowAddWechat == true ? "是" : "否"
              );
            });
            this.tablePagination = {
              showQuickJumper: true,
              showTotal: () => `共${res.data.total}条`,
              pageSize: data.pageSize,
              current: data.pageNo,
              total: res.data.total,
              onChange: (current) => this.changePageItem(current),
            };
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    Export() {
      if (
        !this.allowAddWechat ||
        !this.lastLoginDateStartTime ||
        !this.lastLoginDateEndTime
      ) {
        this.allowAddWechat =
          this.lastLoginDateStartTime =
          this.lastLoginDateEndTime =
            "";
      }
      location.href =
        process.env.VUE_APP_CURRENTMODE == "dev"
          ? process.env.VUE_APP_BASE_API
          : location.origin +
            `/api/manager/loanUser/export?pageNo=${this.pageNo}&pageSize=10&phone=${this.phone}&channel=${this.channel}&allowAddWechat=${this.allowAddWechat}&startTime=${this.lastLoginDateStartTime}&endTime=${this.lastLoginDateEndTime}`;
    },
    // 翻页
    changePageItem(index) {
      this.query(index);
    },
    // 不可选的登录日期
    disabledLastLoginStartDate(startValue) {
      const endValue = this.lastLoginDateEnd;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledLastLoginEndDate(endValue) {
      const startValue = this.lastLoginDateStart;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
  },
};
</script>
<style lang="scss">
.loanUser {
  background-color: #fff;
  padding: 20px;
}
</style>
